import {useEffect} from "react"
import {Link, useHistory} from "react-router-dom"
import Avatar from "@components/avatar"
import {
    CheckCircle, List, XCircle
} from "react-feather"
import {
    Button,
    Row,
    Col,
    Spinner, UncontrolledTooltip
} from "reactstrap"
import img4 from "@src/assets/images/avatars/avatar-blank.png"
import {getRdCampaigns} from "@src/views/rds/brandCampaigns/store/actions"
import {useSelector, useDispatch} from "react-redux"
import CustomPagination from '@src/views/components/pagination/CustomPagination'
import queryString from "query-string"

import { OutreachAvailabilityBadge, OutreachActionButton } from "@src/views/components/outreach/OutreachCardElements"

const RecommendedBrandCampaigns = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const {
        rdRecommendedCampaignsLoading,
        rdRecommendedCampaignsFullFill,
        rdRecommendedCampaignsError
    } = useSelector((store) => store.rdCampaigns)

    useEffect(() => {
        dispatch(getRdCampaigns(""))
    }, [])

    const handleCustomPagination = pageUrl => {
        const parsed = queryString.parseUrl(pageUrl)
        const pageNo = parsed?.query?.page
        dispatch(getRdCampaigns(`?page=${pageNo}`))
    }

    const getAppliedCampaignData = (campaign) => {
        if (campaign?.version === 'v2') {
            history.push(`/rd/apply-on-campaign/${campaign?.id}/view`)
        } else {
            history.push(`/dashboard/rd/campaigns`)
        }
    }

    const getApplyLink = (campaign) => {
        if (campaign?.version === 'v2') {
            return `/rd/apply-on-campaign/${campaign?.id}`
        } else {
            return `/dashboard/rd/campaign-application/${campaign?.id}`
        }
    }

    return (
        <>
            {rdRecommendedCampaignsLoading ? (
                <div className="d-flex justify-content-center" style={{height: '200px'}}>
                    <div className="align-self-center">
                        <Spinner color='primary'/>
                    </div>
                </div>
            ) : (
                rdRecommendedCampaignsFullFill?.data?.length > 0 && (
                    <>
                        <h3 className="mb-2">
                            Recommended Brand Outreach
                        </h3>
                        <div className="brandSlides">
                            <Row className="match-height">
                                {rdRecommendedCampaignsFullFill?.data?.map((rdCamps, index) => {
                                    const isFull = Boolean(rdCamps?.is_full) || rdCamps?.spots_left === 0
                                    return (
                                        <Col sm="6" md="4" lg="3" key={index} className="mb-4">
                                            <div
                                                className="full-height brandContent text-center p-3 d-flex flex-column justify-content-between"
                                                style={{
                                                    position: 'relative',
                                                    opacity: isFull ? 0.7 : 1,
                                                    backgroundColor: '#ffffff',
                                                    border: '1px solid #EAEAEA',
                                                    borderRadius: '16px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.03)'
                                                }}
                                            >
                                                <OutreachAvailabilityBadge
                                                    isFull={isFull}
                                                    spotsLeft={rdCamps?.spots_left}
                                                />
                                                <div className="d-flex flex-column align-items-center w-100">
                                                    <Avatar img={rdCamps?.brand_img || img4} imgHeight="72" imgWidth="72" className="avatar-img-fit-contain mt-1 mb-2" />
                                                    <h4 className="text-break font-weight-bold text-center mb-2" title={rdCamps?.campaign_title || "N/A"} style={{color: "#111111", fontSize: "16px", lineHeight: "1.3"}}>
                                                        {rdCamps?.campaign_title?.length > 40 ? `${rdCamps?.campaign_title.substring(0, 40)}...` : rdCamps?.campaign_title}
                                                    </h4>
                                                </div>
                                                <div className="w-100 mt-1">
                                                    <OutreachActionButton
                                                        campaign={rdCamps}
                                                        onViewApplied={getAppliedCampaignData}
                                                        applyPath={getApplyLink(rdCamps)}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })}
                            </Row>
                            <Row className="pt-2 justify-content-centered">
                                <Col md="12">
                                    <CustomPagination pageLinks={rdRecommendedCampaignsFullFill?.pages}
                                                      onPaginationClick={handleCustomPagination}/>
                                </Col>
                            </Row>
                        </div>
                    </>
                )
            )}
        </>
    )
}

export default RecommendedBrandCampaigns
